import React from 'react';

export const JCB = () => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_7846_182996)">
      <path
        d="M40.8594 31.4282C40.8594 32.7341 39.8008 33.7928 38.4949 33.7928H3.22383C1.91797 33.7928 0.859375 32.734 0.859375 31.4282V8.57156C0.859375 7.26563 1.91797 6.20703 3.22383 6.20703H38.4948C39.8008 6.20703 40.8593 7.2657 40.8593 8.57156L40.8594 31.4282Z"
        fill="#F4F4F4"
      />
      <path
        opacity="0.15"
        d="M2.54039 31.4282V8.57156C2.54039 7.26563 3.59914 6.20703 4.905 6.20703H3.22375C1.91797 6.20703 0.859375 7.26578 0.859375 8.57156V31.428C0.859375 32.734 1.91797 33.7927 3.22383 33.7927H4.90508C3.59922 33.7928 2.54039 32.734 2.54039 31.4282Z"
        fill="#CFCFCF"
      />
      <g clipPath="url(#clip1_7846_182996)">
        <path
          d="M34.751 26.3633C34.751 28.747 32.8151 30.688 30.4377 30.688H6.96875V13.5592C6.96875 11.1754 8.90468 9.23438 11.2821 9.23438H34.751V26.3633Z"
          fill="#F4F4F4"
        />
        <path
          d="M27.1094 21.9705H28.8925C28.9434 21.9705 29.0623 21.9535 29.1132 21.9535C29.4529 21.8854 29.7416 21.5789 29.7416 21.1532C29.7416 20.7446 29.4529 20.4381 29.1132 20.353C29.0623 20.3359 28.9604 20.3359 28.8925 20.3359H27.1094V21.9705Z"
          fill="url(#paint0_linear_7846_182996)"
        />
        <path
          d="M28.6897 10.6797C26.9915 10.6797 25.599 12.0589 25.599 13.7786V16.9966H29.9633C30.0652 16.9966 30.1841 16.9966 30.269 17.0136C31.254 17.0647 31.9842 17.5755 31.9842 18.4609C31.9842 19.159 31.4917 19.7549 30.5747 19.8741V19.9082C31.5766 19.9763 32.3408 20.5382 32.3408 21.4065C32.3408 22.343 31.4917 22.956 30.3709 22.956H25.582V29.2558H30.1162C31.8144 29.2558 33.2069 27.8767 33.2069 26.157V10.6797H28.6897Z"
          fill="url(#paint1_linear_7846_182996)"
        />
        <path
          d="M29.5208 18.6671C29.5208 18.2585 29.2321 17.9861 28.8925 17.935C28.8585 17.935 28.7736 17.918 28.7226 17.918H27.1094V19.4163H28.7226C28.7736 19.4163 28.8755 19.4163 28.8925 19.3993C29.2321 19.3482 29.5208 19.0758 29.5208 18.6671Z"
          fill="url(#paint2_linear_7846_182996)"
        />
        <path
          d="M11.6038 10.6797C9.90559 10.6797 8.51308 12.0589 8.51308 13.7786V21.4236C9.37915 21.8492 10.2792 22.1216 11.1792 22.1216C12.2491 22.1216 12.8265 21.4746 12.8265 20.5892V16.9796H15.4756V20.5722C15.4756 21.9684 14.6096 23.1092 11.6717 23.1092C9.8886 23.1092 8.49609 22.7176 8.49609 22.7176V29.2388H13.0302C14.7284 29.2388 16.1209 27.8597 16.1209 26.14V10.6797H11.6038Z"
          fill="url(#paint3_linear_7846_182996)"
        />
        <path
          d="M20.1454 10.6797C18.4472 10.6797 17.0547 12.0589 17.0547 13.7786V17.8309C17.8359 17.1669 19.1944 16.7412 21.3851 16.8434C22.5568 16.8944 23.8135 17.2179 23.8135 17.2179V18.529C23.1851 18.2055 22.4379 17.916 21.47 17.8479C19.8057 17.7288 18.8038 18.546 18.8038 19.9763C18.8038 21.4236 19.8057 22.2408 21.47 22.1046C22.4379 22.0365 23.1851 21.73 23.8135 21.4236V22.7346C23.8135 22.7346 22.5738 23.0581 21.3851 23.1092C19.1944 23.2114 17.8359 22.7857 17.0547 22.1216V29.2729H21.5888C23.287 29.2729 24.6795 27.8937 24.6795 26.174V10.6797H20.1454Z"
          fill="url(#paint4_linear_7846_182996)"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_7846_182996"
        x1="25.5952"
        y1="21.1553"
        x2="33.2263"
        y2="21.1553"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#007940" />
        <stop offset="0.2285" stopColor="#00873F" />
        <stop offset="0.7433" stopColor="#40A737" />
        <stop offset="1" stopColor="#5CB531" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_7846_182996"
        x1="25.5959"
        y1="19.9603"
        x2="33.2277"
        y2="19.9603"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#007940" />
        <stop offset="0.2285" stopColor="#00873F" />
        <stop offset="0.7433" stopColor="#40A737" />
        <stop offset="1" stopColor="#5CB531" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_7846_182996"
        x1="25.595"
        y1="18.665"
        x2="33.2265"
        y2="18.665"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#007940" />
        <stop offset="0.2285" stopColor="#00873F" />
        <stop offset="0.7433" stopColor="#40A737" />
        <stop offset="1" stopColor="#5CB531" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_7846_182996"
        x1="8.50948"
        y1="19.9603"
        x2="16.2588"
        y2="19.9603"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1F286F" />
        <stop offset="0.4751" stopColor="#004E94" />
        <stop offset="0.8261" stopColor="#0066B1" />
        <stop offset="1" stopColor="#006FBC" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_7846_182996"
        x1="17.0108"
        y1="19.9603"
        x2="24.5372"
        y2="19.9603"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6C2C2F" />
        <stop offset="0.1735" stopColor="#882730" />
        <stop offset="0.5731" stopColor="#BE1833" />
        <stop offset="0.8585" stopColor="#DC0436" />
        <stop offset="1" stopColor="#E60039" />
      </linearGradient>
      <clipPath id="clip0_7846_182996">
        <rect
          width="40"
          height="40"
          fill="white"
          transform="translate(0.859375)"
        />
      </clipPath>
      <clipPath id="clip1_7846_182996">
        <rect
          width="27.9688"
          height="21.6406"
          fill="white"
          transform="translate(6.875 9.14062)"
        />
      </clipPath>
    </defs>
  </svg>
);
